import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getProductCategory, safelyDecodeCategorySlug } from "@/lib/productCategories";

const isIndexableRoute = (pathname: string) =>
  pathname === "/" ||
  pathname === "/gemfinder" ||
  (pathname.startsWith("/category/") && Boolean(getProductCategory(safelyDecodeCategorySlug(pathname.split("/")[2] || "")))) ||
  pathname.startsWith("/product/") ||
  pathname === "/blog" ||
  pathname.startsWith("/blog/") ||
  pathname.startsWith("/guides/") ||
  pathname === "/contact-us" ||
  pathname === "/terms-conditions" ||
  pathname === "/privacy-policy" ||
  pathname === "/shipping-policy" ||
  pathname === "/cancellation-refunds" ||
  pathname.startsWith("/campaigns/");

const routeTitle = (pathname: string) => {
  if (pathname === "/cart") return "Shopping Cart | Uma's Aura";
  if (pathname === "/wishlist") return "Wishlist | Uma's Aura";
  if (pathname === "/auth") return "Sign In | Uma's Aura";
  if (pathname === "/checkout") return "Checkout | Uma's Aura";
  if (pathname === "/order-success") return "Order Confirmed | Uma's Aura";
  if (pathname === "/orders") return "Order History | Uma's Aura";
  if (pathname === "/profile") return "My Profile | Uma's Aura";
  if (pathname === "/gemfinder") return null;
  if (pathname.startsWith("/order/")) return "Order Details | Uma's Aura";
  if (pathname === "/admin/dashboard") return "Admin Dashboard | Uma's Aura";
  if (pathname.startsWith("/admin/orders/")) return "Admin Order Details | Uma's Aura";
  if (pathname === "/admin/orders" || pathname === "/admin") return "Admin Orders | Uma's Aura";
  if (pathname.startsWith("/admin/")) return "Admin Panel | Uma's Aura";
  if (pathname.startsWith("/campaigns/")) return "Uma's Aura Campaign";
  if (
    pathname === "/" ||
    pathname === "/gemfinder" ||
    pathname.startsWith("/category/") ||
    pathname.startsWith("/product/") ||
    pathname === "/blog" ||
    pathname.startsWith("/blog/") ||
    pathname.startsWith("/guides/") ||
    pathname === "/contact-us" ||
    pathname === "/terms-conditions" ||
    pathname === "/privacy-policy" ||
    pathname === "/shipping-policy" ||
    pathname === "/cancellation-refunds"
  ) return null;
  return "Page Not Found | Uma's Aura";
};

export function RouteMetadata() {
  const { pathname } = useLocation();
  const title = routeTitle(pathname);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    if (title) document.title = title;
  }, [pathname, title]);

  return (
    <Helmet>
      {title && <title>{title}</title>}
      <meta
        name="robots"
        content={isIndexableRoute(pathname) ? "index, follow, max-image-preview:large" : "noindex, nofollow"}
      />
    </Helmet>
  );
}
